import { 
    Wind, Flame, Droplets, Shirt, 
    Wrench, Scissors, Home, Sun, Satellite, 
    PanelTop, ArrowUpToLine, Scroll, Ruler, Tent, Activity 
} from "lucide-react";

export const standardVisualMeasurement = [
    "Roof Vent",
    "Pipe Jack",
    "Furnace Vents",
    "Bathroom Vents",
    "Dryer Vents",
    "Split Boots",
    "Headwall",
    "Roll Metal",
    "Soffit Length",
    "Chimney",
    "Skylights",
    "Open Patio/Soffits",
    "Satellite Dish",
    "Solar Panels",
];

export const measurementGroups: Record<string, string[]> = {
    Vents: ["Roof Vent", "Furnace Vents", "Bathroom Vents", "Dryer Vents"],
    Penetrations: ["Pipe Jack", "Split Boots", "Chimney", "Skylights", "Satellite Dish", "Solar Panels"],
    "Structure & Metal": ["Headwall", "Roll Metal", "Soffit Length", "Open Patio/Soffits"],
};

export type Measurement = {
    Id: string;
    ActualValue: number;
    [key: string]: any;
};

export interface IVisualMeasurement {
    measurements: any;
    setMeasurements: (e: any) => void;
    attributes: any;
    setAttributes: (e: any) => void;
}

export const getMeasurementIcon = (name: string) => {
    switch(name) {
        case "Roof Vent": return <Wind size={16} />;
        case "Furnace Vents": return <Flame size={16} />;
        case "Bathroom Vents": return <Droplets size={16} />;
        case "Dryer Vents": return <Shirt size={16} />;
        case "Pipe Jack": return <Wrench size={16} />;
        case "Split Boots": return <Scissors size={16} />;
        case "Headwall": return <ArrowUpToLine size={16} />;
        case "Roll Metal": return <Scroll size={16} />;
        case "Soffit Length": return <Ruler size={16} />;
        case "Chimney": return <Home size={16} />;
        case "Skylights": return <Sun size={16} />;
        case "Open Patio/Soffits": return <Tent size={16} />;
        case "Satellite Dish": return <Satellite size={16} />;
        case "Solar Panels": return <PanelTop size={16} />;
        default: return <Activity size={16} />;
    }
};
